import type { ScheduledTask, ScheduledTaskStatus } from "../types";

/**
 * ⚠️⚠️ **`failed` ro'yxatda YO'Q va bu ataylab.** Reja matni «status
 * bo'yicha filtr: `failed`» degan edi, lekin `scheduled_task_status`
 * enumida bunday qiymat yo'q — yiqilgan vazifa `cancelled` +
 * `last_error` bo'lib yoziladi. `status=failed` so'rovi backendda 400
 * bilan rad etilardi.
 */
export const VAZIFA_HOLATLARI: readonly ScheduledTaskStatus[] = [
	"pending",
	"processing",
	"deferred",
	"done",
	"cancelled",
];

/**
 * Holat rangi — yorliq MATNI endi shu yerda EMAS, `jobs.json`dagi
 * `scheduledTasks.status.*` i18n kalitlaridan (`useTranslation("jobs")`,
 * P7 i18n). Bu obyekt faqat rangni beradi.
 *
 * ⚠️ `cancelled` — yiqilgan vazifaning ham holati (`last_error` bilan),
 * shuning uchun rang neytral emas, ogohlantiruvchi (`red`).
 *
 * ⚠️ Yorliq ATAYLAB «To'xtatilgan» EMAS: shu so'z navbat kartasida
 * `paused` bayrog'i uchun ishlatiladi va bir sahifada ikki xil
 * tushuncha bitta so'z bilan chiqardi.
 */
export const HOLAT_RANGLARI: Record<ScheduledTaskStatus, string> = {
	pending: "blue",
	processing: "processing",
	deferred: "gold",
	done: "green",
	cancelled: "red",
};

/**
 * Vazifa turlari — `SCHEDULED_TASK_KINDS` (`packages/core`) ning nusxasi.
 *
 * ⚠️ Frontend `@skud/core` ga bog'lanmaydi (uning workspace bog'lanishlari
 * faqat `@skud/domain` va `@skud/shared`), shuning uchun ro'yxat shu yerda
 * takrorlanadi. Yangi tur qo'shilganda ikkalasi birga yangilanadi; xato
 * qilinsa filtr opsiyasi kam bo'ladi, lekin jadval baribir to'liq
 * ko'rinadi (tur ustuni XOM qiymatni ko'rsatadi).
 */
export const VAZIFA_TURLARI = ["exit_decision", "shift_close", "task_deadline"];

/**
 * `runSchedulerTick` qotib qolgan vazifani qayta oladigan chegara
 * (`locked_at < now() - 5 daq`, 1c mexanizmi).
 */
const QOTISH_CHEGARASI_MS = 5 * 60_000;

/**
 * ⚠️ `locked_at IS NULL` ham QOTIB QOLGAN deb hisoblanadi: backendda bu
 * qorovul MAJBURIY (`NULL < vaqt` hech qachon ROST emas va qator abadiy
 * band qolardi), ya'ni `runSchedulerTick` bunday qatorni aynan shunday
 * qayta oladi.
 */
export function qotibQolgan(task: ScheduledTask): boolean {
	if (task.status !== "processing") {
		return false;
	}
	if (task.lockedAt === null) {
		return true;
	}

	return Date.now() - new Date(task.lockedAt).getTime() > QOTISH_CHEGARASI_MS;
}

/**
 * Retry taqiqining SABAB KODI, yoki `null` — taqiq yo'q.
 *
 * ⚠️ Bu funksiya endi TARJIMA QILINGAN matn qaytarmaydi (P7 i18n) — UI
 * qatlami kodni `t("scheduledTasks.retryBlockedProcessing")` bilan
 * matnga aylantiradi (`ScheduledTasksTable.tsx`).
 *
 * ⚠️⚠️ **`processing` vazifa RETRY QILINMAYDI.** Worker ayni paytda uni
 * bajarayotgan bo'lishi mumkin va `pending` ga qaytarish IKKINCHI
 * bajaruvchini yaratardi — `exit_decision` ikki marta ishlab, bir kunga
 * ikki `departure` hodisasi yozilardi. Backend 422 beradi
 * (`messages.jobs.taskProcessing`), UI esa tugmani oldindan o'chiradi va
 * sababni tooltip'da tushuntiradi.
 */
export function retryTaqiqi(task: ScheduledTask): "processing" | null {
	return task.status === "processing" ? "processing" : null;
}
